import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { ArchiveIcon, BookmarkIcon, FeedIcon, SlidersIcon } from "./icons";

export function BottomNav() {
  const { t } = useTranslation();
  return (
    <nav className="bottom-nav" aria-label={t("nav.main")}>
      <NavLink to="/" end className="bottom-nav-item">
        <FeedIcon />
        <span>{t("nav.feed")}</span>
      </NavLink>
      <NavLink to="/saved" className="bottom-nav-item">
        <BookmarkIcon />
        <span>{t("nav.saved")}</span>
      </NavLink>
      <NavLink to="/dismissed" className="bottom-nav-item">
        <ArchiveIcon />
        <span>{t("nav.dismissed")}</span>
      </NavLink>
      <NavLink to="/settings" className="bottom-nav-item">
        <SlidersIcon />
        <span>{t("nav.settings")}</span>
      </NavLink>
    </nav>
  );
}
